import CsLine from './lineChart.vue'
CsLine.install = function (Vue) {
  Vue.component(CsLine.name, CsLine);
}

import CsPie from './pieChart.vue'
CsPie.install = function (Vue) {
  Vue.component(CsPie.name, CsPie);
}

import DgCsPie from './dgPieChart.vue'
DgCsPie.install = function (Vue) {
  Vue.component(DgCsPie.name, DgCsPie);
}

import DgDonut from './dgDonutChart.vue'
DgDonut.install = function (Vue) {
  Vue.component(DgDonut.name, DgDonut);
}

import WsPie from './wsPie.vue'
WsPie.install = function (Vue) {
  Vue.component(WsPie.name, WsPie);
}

import TitlePie from './pieTitleChart.vue'
TitlePie.install = function (Vue){
  Vue.component(TitlePie.name, TitlePie);
}

import CsMap from './mapChart.vue'
CsMap.install = function (Vue) {
  Vue.component(CsMap.name, CsMap);
}

import CsBar from './barChart.vue'
CsBar.install = function (Vue) {
  Vue.component(CsBar.name, CsBar);
}

import CsStackBar from './stackBarChart.vue'
CsStackBar.install = function (Vue) {
  Vue.component(CsStackBar.name, CsStackBar);
}

import WbBar from './wbarChart.vue'
WbBar.install = function (Vue) {
  Vue.component(WbBar.name, WbBar);
}

import HorBar from './horBar.vue'
HorBar.install = function (Vue) {
  Vue.component(HorBar.name, HorBar);
}
export default [CsLine,CsPie,TitlePie,CsMap,CsBar,CsStackBar,WbBar,WsPie,DgCsPie,DgDonut,HorBar]



// WEBPACK FOOTER //
// ./src/components/echarts/index.js